import { CompanyContext } from '@/contexts/CompanyContext';
import { use } from 'react';

export function useCompany() {
  const context = use(CompanyContext);
  if (context === undefined) {
    throw new Error('useCompany must be used within a CompanyProvider');
  }
  return context;
}
